import { Button } from '@mui/material';
import React, { useState } from 'react';
import { FaUpload } from 'react-icons/fa';

function ZeroOut() {
  const [zeroOuts, setZeroOuts] = useState('');
  const doZeroOut = () => {};

  return (
    <div className="p-6">
      <h1 className="text-gray-200 text-4xl font-semibold">Import Inventory</h1>
      <div className="grid grid-cols-2 gap-10 w-fit">
        <div className="rounded-lg border border-[#81848f3d] w-[450px] mt-8 p-3 flex flex-col justify-between">
          <div className="mx-4">
            <p className="text-gray-400 mb-6">Zero-out</p>
            <div>
              <input
                className="block w-full h-[30px] file:h-[30px] text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer 
          dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
          file:text-white file:bg-[#1565c0] file:border-0 file:cursor-pointer"
                id="file_input"
                accept=".csv"
                type="file"
              />
              <p className="text-gray-400 mt-1 text-sm" id="file_input_help">
                SKU CSV file
              </p>
            </div>
            <p className="text-gray-400 mt-10 text-sm" id="file_input_help">
              OR enter SKUs manually
            </p>
            <textarea
              id="message"
              rows={4}
              onChange={(e) => setZeroOuts(e.target.value)}
              value={zeroOuts}
              className="block p-2.5 w-full  text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Your message..."
            ></textarea>
          </div>

          <div className="w-full flex justify-end mt-5">
            <Button
              variant="contained"
              sx={{ backgroundColor: '' }}
              endIcon={<FaUpload />}
              onClick={doZeroOut}
            >
              Upload
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ZeroOut;
